




import { Vue } from 'vue-property-decorator';
export default class EmailConfig extends Vue {}
